<template>
  <v-layout justify-center>
    <v-flex xs12 sm10 md10>
      <v-layout>
        <v-flex xm12 sm4>
          <v-autocomplete
            :items="searchSelect"
            v-model="searchType"
            menu-props="auto"
            label="Year"
            hide-details
            solo
            @change="searchYear"
          ></v-autocomplete>
        </v-flex>
        <v-flex xm12 sm8 class="display-1 text-sm-right">
          <v-btn round outline color="primary" @click="buildEmail('chairs')" :disabled="!selected" style="margin: 6px 0;">
            <v-icon>email</v-icon>
            Chairs
          </v-btn>
          <v-btn round outline color="primary" @click="buildEmail('both')" :disabled="!selected" style="margin: 6px 0;">
            <v-icon>email</v-icon>
            Chairs/Assist
          </v-btn>
          <v-tooltip bottom>
            <v-btn fab outline small color="primary" @click="onExport" slot="activator" :disabled="!selected" style="margin: 6px 0;">
              <v-icon>cloud_download</v-icon>
            </v-btn>
            <span>Download Selected Chairs and Assistant Chairs</span>
          </v-tooltip>

        </v-flex>
      </v-layout>

      <vue-good-table
        ref="my-table"
        styleClass="vgt-table striped bordered"
        :max-height=this.height
        :fixed-header="true"
        :columns="columns"
        :rows="rows"
        @on-cell-click="onCellClick"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true
        }"
        :search-options="{
          enabled: true
        }">
        <div slot="table-actions">
        </div>
        <div slot="table-actions-bottom">
          <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'name'">
            <span class="font-weight-bold">{{props.row.name}}</span> ({{props.row.code}})<br />
            <span class="caption font-weight-medium font-italic">{{props.row.group}}</span>
          </span>
          <span v-else-if="props.column.field == 'chairs'">
            <div class="text-xs-center text-sm-left">
              <div v-for="(chair, i) in props.row.chairs" :key="i">
                <v-chip style="float: left; z-index: 0;" @click="getUser(chair.id)">
                  <v-avatar color="indigo">
                    <img v-if="chair.image" v-lazy="chair.picture" :alt="chair.name" />
                    <span v-else class="white--text">{{ chair.firstName.substr(0, 1) }}{{ chair.lastName.substr(0, 1) }}</span>
                  </v-avatar>
                  {{ chair.name }}
                </v-chip>
              </div>
            </div>
          </span>
          <span v-else-if="props.column.field == 'assistchairs'">
            <div class="text-xs-center text-sm-left">
              <div v-for="(chair, i) in props.row.assistchairs" :key="i">
                <v-chip style="float: left; z-index: 0;">
                  <v-avatar color="indigo">
                    <img v-if="chair.image" v-lazy="chair.picture" :alt="chair.name" />
                    <span v-else class="white--text">{{ chair.firstName.substr(0, 1) }}{{ chair.lastName.substr(0, 1) }}</span>
                  </v-avatar>
                  {{ chair.name }}
                </v-chip>
              </div>
            </div>
          </span>
          <span v-else-if="props.column.field == 'actions' && isAdmin">
            <div class="text-xs-center">
              <v-avatar
                color="blue lighten-4"
                class="mr-2 mt-2"
                size="30"
                style="cursor: pointer;"
                @click="editCommittee(props)"
              >
                <v-icon small>edit</v-icon>
              </v-avatar>
            </div>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
    </v-flex>

    <v-btn
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click="newItem()"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="500px" lazy>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md6 order-xs2 order-md1>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.name" v-on:keyup.enter="save" label="Name" ref="focusItem" prepend-icon='perm_identity'></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.diet" v-on:keyup.enter="save" label="Diet" prepend-icon='cake'></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.count" v-on:keyup.enter="save" label="Count" prepend-icon='looks_one'></v-text-field>
                </v-flex>
              </v-flex>
              <v-flex xs12 md6 order-xs1 order-md2 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <v-flex xs12 text-xs-center>
                  <croppa
                    v-model="croppa"
                    :initial-image="initialImage"
                    :placeholder-font-size="14"
                    :prevent-white-space="true"
                    :disable-drag-and-drop="false"
                    :width="180"
                    :height="180"
                    :zoom-speed="7"
                  >
                  </croppa>
                  <!-- <v-btn flat icon color="primary" small @click="croppa.moveUpwards(10)"><v-icon>arrow_upward</v-icon></v-btn>
                  <v-btn flat icon color="primary" small @click="croppa.moveDownwards(10)"><v-icon>arrow_downward</v-icon></v-btn>
                  <v-btn flat icon color="primary" small @click="croppa.moveLeftwards(10)"><v-icon>arrow_back</v-icon></v-btn>
                  <v-btn flat icon color="primary" small @click="croppa.moveRightwards(10)"><v-icon>arrow_forward</v-icon></v-btn> -->
                  <v-btn flat icon color="primary" small @click="croppa.rotate(-1)"><v-icon>rotate_left</v-icon></v-btn>
                  <v-btn flat icon color="primary" small @click="croppa.rotate()"><v-icon>rotate_right</v-icon></v-btn>
                  <!-- <v-btn flat icon color="primary" small @click="croppa.zoomIn()"><v-icon>zoom_in</v-icon></v-btn>
                  <v-btn flat icon color="primary" small @click="croppa.zoomOut()"><v-icon>zoom_out</v-icon></v-btn> -->
                  </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="red darken-1" flat @click.native="deleteItem">Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewDialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md6 order-xs2 order-md1>
                <v-flex xs12 class="text-xs-center text-sm-center">
                  <span class="headline">{{ editedItem.name }}</span><br />
                  <span class="subheading">({{ editedItem.title }})</span>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    v-if="editedItem.email"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="sendEmail"
                  >
                    Email {{editedItem.firstName}}
                    <v-icon right dark>email</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editedItem.cellPhone"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="callMobile"
                  >
                    Call Mobile
                    <v-icon right dark>mobile_screen_share</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editedItem.homePhone"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="callHome"
                  >
                    Call Home
                    <v-icon right dark>phone</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editedItem.workPhone"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="callWork"
                  >
                    Call Work
                    <v-icon right dark>business</v-icon>
                  </v-btn>
                </v-flex>
              </v-flex>
              <v-flex xs12 md6 order-xs1 order-md2 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <img :src="editedItem.picture" height="150" v-if="editedItem.image"/>
                <v-icon v-else x-large color="blue">person</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="emailDialog" max-width="1000px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-flex xs12>
                  <span class="headline">Email</span><br />
                </v-flex>
              </v-flex>
              <v-flex xs12>
                <v-combobox
                  v-model="emails"
                  :items="rows"
                  label="Email Addresses"
                  chips
                  clearable
                  prepend-icon="filter_list"
                  solo
                  multiple
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                      :selected="data.selected"
                      close
                      @input="remove(data.item)"
                    >
                      <v-avatar>
                        <img :src="data.item.picture" :alt="data.item.name">
                      </v-avatar>
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <EmailForm
      :visible="showEmailForm"
      :items="emailList"
      :selectedItems="emails"
      @close="closeThis"
    />

    <CommitteeForm
      :visible="showCommitteeForm"
      :item="item"
      :isEdit="isEdit"
      @close="closeThis"
    />

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import 'vue-croppa/dist/vue-croppa.css'
import EmailForm from '../forms/EmailForm'
import CommitteeForm from '../forms/CommitteeForm'
import XLSX from 'xlsx'

export default {
  components: {
    VueGoodTable,
    EmailForm,
    CommitteeForm
  },
  data () {
    return {
      currentPage: 'Committees',
      searchSelect: [],
      searchType: '',
      dialog: false,
      isEdit: false,
      showCommitteeForm: false,
      croppa: {},
      initialImage: null,
      dataURL: '',
      viewDialog: false,
      emailDialog: false,
      loading: false,
      isMounted: false,
      isAdmin: this.$store.isAdmin,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Chair(s)',
          field: 'chairs',
          thClass: 'hidden-sm-and-down',
          tdClass: 'hidden-sm-and-down',
          sortable: false
        },
        {
          label: 'Assist Chair(s)',
          field: 'assistchairs',
          thClass: 'hidden-sm-and-down',
          tdClass: 'hidden-sm-and-down',
          sortable: false
        },
        {
          label: 'Action',
          field: 'actions',
          sortable: false,
          hidden: false,
          html: true,
          width: '120px'
        }
      ],
      rows: [],
      exportFields: {
        'id': 'id',
        'Name': 'name',
        'Image': 'image',
        'Picture': 'picture',
        'Image File': 'imageFile',
        'Data Url': 'dataUrl',
        'Diet': 'diet',
        'Count': 'count'
      },
      editedItem: {
        id: 0,
        name: '',
        image: '',
        picture: '',
        imageFile: '',
        dataUrl: '',
        diet: '',
        count: 0
      },
      defaultItem: {
        id: 0,
        name: '',
        image: '',
        picture: '',
        imageFile: '',
        dataUrl: '',
        diet: '',
        count: 0
      },
      item: {
        id: 1,
        name: 'Test Comm',
        code: 'TC',
        byLaws: false,
        active: true,
        year: 2019,
        ExecGroupId: 85,
        parentId: 462,
        notes: 'Now is the time for all good men to come to the aid of their party.'
      },
      showEmailForm: false,
      emails: [],
      emailList: [],
      currentYear: 0
    }
  },

  created () {
    this.$store.dispatch('setCurrentPage', this.currentPage)

    this.currentYear = this.$store.state.currentYear
    this.yearList()

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getCommittees()
    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    dialog (val) {
      this.$nextTick(this.$refs.focusItem.focus)
      val || this.close()
    }
  },

  methods: {
    yearList () {
      for (let i = this.$store.state.currentYear; i >= 2013; i--) {
        let yearItem = {
          text: i,
          value: i
        }

        this.searchSelect.push(yearItem)
      }
    },

    handleResize () {
      const height = window.innerHeight - 300
      this.height = height + 'px'
    },

    onCellClick (params) {
      if (params.column.field === 'name') {
        this.editedItem.name = params.row.code
        this.$router.push('/committees/' + params.row.code + '/' + this.currentYear)
      }
      // params.row - row object
      // params.column - column object
      // params.rowIndex - index of this row on the current page.
      // params.event - click event
    },

    getUser (userId) {
      console.log(userId)
    },

    newItem () {
      let image = new Image()
      image.setAttribute('crossorigin', 'anonymous')
      image.src = ''

      this.initialImage = image
      this.croppa.refresh()

      this.dialog = true
    },

    editItem (props) {
      let image = new Image()
      image.setAttribute('crossorigin', 'anonymous')
      image.src = props.row.picture

      this.initialImage = image
      this.croppa.refresh()

      this.editedIndex = props.index
      this.editedItem.id = props.row.id
      this.editedItem.name = props.formattedRow.name
      this.editedItem.diet = props.formattedRow.diet
      this.editedItem.count = props.formattedRow.count
      this.editedItem.image = props.row.image
      this.editedItem.picture = props.row.picture
      this.dialog = true
    },

    save () {
      this.editedItem.dataUrl = this.croppa.generateDataUrl('image/jpeg', 0.8)
      // console.log(this.editedItem.dataUrl)

      if (this.editedIndex > -1) {
        // console.log('Update')
        this.updateItem(this.editedItem)
      } else {
        // console.log('Save')
        this.addItem(this.editedItem)
        this.rows.push(this.editedItem)
      }

      this.close()
    },

    deleteItem () {
      let r = confirm('Are you sure you want to delete ' + this.editedItem.name + '?')

      if (r === true) {
        this.rows.splice(this.editedIndex, 1)
        this.removeItem(this.editedItem.id)
      }

      this.close()
    },

    deleteItemList (props) {
      let r = confirm('Are you sure you want to delete ' + props.formattedRow.name + '?')

      if (r === true) {
        this.rows.splice(props.index, 1)
        this.removeItem(props.row.id)
      }
    },

    searchYear () {
      this.currentYear = this.searchType
      this.getCommittees()
    },

    async getCommittees () {
      try {
        const response = await Api().get('get_committeelist/' + this.currentYear)
        console.log(response.data)

        let CommitteeList = []
        let CommitteeChairs = []
        let CommitteeAssistChairs = []
        let committeeName = ''

        for (let i in response.data) {
          let group = ''

          if (response.data[i].ExecGroup) {
            group = response.data[i].ExecGroup.group
          }

          if (response.data[i].parentId === null) {
            committeeName = response.data[i].name
          } else {
            committeeName = response.data[i].parent.name + '->' + response.data[i].name
          }

          for (let j in response.data[i].Users) {
            if (response.data[i].Users[j].UserCommittee.title === 'Chair') {
              let chairItem = {
                id: response.data[i].Users[j].id,
                name: response.data[i].Users[j].fullName,
                firstName: response.data[i].Users[j].firstName,
                lastName: response.data[i].Users[j].lastName,
                picture: response.data[i].Users[j].picture,
                image: response.data[i].Users[j].image,
                email: response.data[i].Users[j].email,
                mobile: response.data[i].Users[j].cellPhone
              }

              CommitteeChairs.push(chairItem)
            }

            if (response.data[i].Users[j].UserCommittee.title === 'Assist Chair') {
              let chairItem = {
                id: response.data[i].Users[j].id,
                name: response.data[i].Users[j].fullName,
                firstName: response.data[i].Users[j].firstName,
                lastName: response.data[i].Users[j].lastName,
                picture: response.data[i].Users[j].picture,
                image: response.data[i].Users[j].image,
                email: response.data[i].Users[j].email,
                mobile: response.data[i].Users[j].cellPhone
              }

              CommitteeAssistChairs.push(chairItem)
            }
          }

          let committeeItem = {
            id: response.data[i].id,
            name: committeeName,
            code: response.data[i].code,
            byLaws: response.data[i].byLaws,
            active: response.data[i].active,
            year: response.data[i].year,
            notes: response.data[i].notes,
            ExecGroupId: response.data[i].ExecGroupId,
            parentId: response.data[i].parentId,
            chairs: CommitteeChairs,
            assistchairs: CommitteeAssistChairs,
            group: group
          }

          CommitteeList.push(committeeItem)

          CommitteeChairs = []
          CommitteeAssistChairs = []
        }

        CommitteeList.sort(function (a, b) {
          let nameA = a.name.toLowerCase()
          let nameB = b.name.toLowerCase()

          if (nameA < nameB) {
            return -1
          }

          if (nameA > nameB) {
            return 1
          }

          return 0
        })

        this.rows = CommitteeList
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async addItem (item) {
      try {
        const response = await Api().post('animals', item)
        this.editedItem.id = response.data.animal.id
        this.editedItem.image = response.data.animal.image
        this.editedItem.picture = response.data.animal.picture

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem (item) {
      try {
        const response = await Api().put('animals/' + item.id, item)
        this.editedItem.image = response.data.body.image
        this.editedItem.picture = response.data.animal.picture

        let newVal = Object.assign(this.rows[this.editedIndex], this.editedItem)
        this.$set(this.rows, this.editedIndex, newVal)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async removeItem (itemId) {
      try {
        const response = await Api().delete('animals/' + itemId)
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    buildEmail (list) {
      // for (let i in this.rows) {
      //   this.emailList[i] = this.rows[i].name
      // }
      // this.ccList = this.emailList
      // this.bccList = this.emailList

      console.log('selected', this.$refs['my-table'].selectedRows)
      let k = 0
      for (let i in this.$refs['my-table'].selectedRows) {
        for (let j in this.$refs['my-table'].selectedRows[i].chairs) {
          this.emails[k] = this.$refs['my-table'].selectedRows[i].chairs[j].name + ' <' + this.$refs['my-table'].selectedRows[i].chairs[j].email + '>'
          k++
        }
        if (list === 'both') {
          for (let j in this.$refs['my-table'].selectedRows[i].assistchairs) {
            this.emails[k] = this.$refs['my-table'].selectedRows[i].assistchairs[j].name + ' <' + this.$refs['my-table'].selectedRows[i].assistchairs[j].email + '>'
            k++
          }
        }
      }

      this.showEmailForm = true

      if (this.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    remove (item) {
      console.log(item)
      this.emails.splice(this.emails.indexOf(item), 1)
      this.emails = [...this.emails]
    },

    editCommittee (props) {
      this.item.id = props.row.id
      this.item.name = props.row.name
      this.item.code = props.row.code
      this.item.byLaws = props.row.byLaws
      this.item.active = props.row.active
      this.item.year = props.row.year
      this.item.notes = props.row.notes
      this.item.ExecGroupId = props.row.ExecGroupId
      this.item.parentId = props.row.parentId

      console.log('props', props)
      console.log('item', this.item)
      this.isEdit = true
      this.showCommitteeForm = true
    },

    closeThis (item) {
      console.log('test')
      this.item = {}
      this.showCommitteeForm = false
      this.emails = []
      this.showEmailForm = false
    },

    close () {
      this.initialImage = null
      this.dialog = false
      this.viewDialog = false
      this.showEmailForm = false

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    onExport () {
      let list = []
      let item = {}

      for (let i in this.$refs['my-table'].selectedRows) {
        for (let j in this.$refs['my-table'].selectedRows[i].chairs) {
          item['Name'] = this.$refs['my-table'].selectedRows[i].name
          item['Title'] = 'Chair'
          item['First Name'] = this.$refs['my-table'].selectedRows[i].chairs[j].firstName
          item['Last Name'] = this.$refs['my-table'].selectedRows[i].chairs[j].lastName
          item['Email'] = this.$refs['my-table'].selectedRows[i].chairs[j].email
          item['Mobile'] = this.$refs['my-table'].selectedRows[i].chairs[j].mobile
          list.push(item)
          item = {}
        }
        for (let j in this.$refs['my-table'].selectedRows[i].assistchairs) {
          item['Name'] = this.$refs['my-table'].selectedRows[i].name
          item['Title'] = 'Assist Chair'
          item['First Name'] = this.$refs['my-table'].selectedRows[i].assistchairs[j].firstName
          item['Last Name'] = this.$refs['my-table'].selectedRows[i].assistchairs[j].lastName
          item['Email'] = this.$refs['my-table'].selectedRows[i].assistchairs[j].email
          item['Mobile'] = this.$refs['my-table'].selectedRows[i].assistchairs[j].mobile
          list.push(item)
          item = {}
        }
      }

      let membersWS = XLSX.utils.json_to_sheet(list)

      let wb = XLSX.utils.book_new()

      if (!wb.Props) { wb.Props = {} }
      wb.Props.Title = 'Insert Title Here'

      XLSX.utils.book_append_sheet(wb, membersWS, 'Chairs-Assist Chairs')

      XLSX.writeFile(wb, 'chairs.xlsx')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}
</style>



// WEBPACK FOOTER //
// src/components/committees/List.vue